var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSide = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#0050C8",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M5 6h14.089M13.111 12h5.978M5 18h14"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0050C8",
  d: "M9.216 11.36c.446.31.446.97 0 1.28l-3.315 2.296a.778.778 0 0 1-1.22-.64V9.704a.778.778 0 0 1 1.22-.639z"
})));
export default SvgSide;